(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9f35"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9f35"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lGKbD", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $fca158e7bc793dc7$export$6503ec6e8aabbaf; }, function (v) { return $fca158e7bc793dc7$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $fca158e7bc793dc7$export$f7ad0328861e2f03; }, function (v) { return $fca158e7bc793dc7$export$f7ad0328861e2f03 = v; });
var $fca158e7bc793dc7$export$6503ec6e8aabbaf;
var $fca158e7bc793dc7$export$f7ad0328861e2f03;
"use strict";
var $fca158e7bc793dc7$var$mapping = new Map();
function $fca158e7bc793dc7$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$fca158e7bc793dc7$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $fca158e7bc793dc7$var$resolve(id) {
    var resolved = $fca158e7bc793dc7$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$fca158e7bc793dc7$export$6503ec6e8aabbaf = $fca158e7bc793dc7$var$register;
$fca158e7bc793dc7$export$f7ad0328861e2f03 = $fca158e7bc793dc7$var$resolve;

});

parcelRegister("17QCl", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $0d1f42a1cefd465e$export$bdfd709ae4826697; }, function (v) { return $0d1f42a1cefd465e$export$bdfd709ae4826697 = v; });
var $0d1f42a1cefd465e$export$bdfd709ae4826697;
var $0d1f42a1cefd465e$export$c9e73fbda7da57b6;
var $0d1f42a1cefd465e$export$5a759dc7a1cfb72a;
"use strict";
var $0d1f42a1cefd465e$var$bundleURL = {};
function $0d1f42a1cefd465e$var$getBundleURLCached(id) {
    var value = $0d1f42a1cefd465e$var$bundleURL[id];
    if (!value) {
        value = $0d1f42a1cefd465e$var$getBundleURL();
        $0d1f42a1cefd465e$var$bundleURL[id] = value;
    }
    return value;
}
function $0d1f42a1cefd465e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $0d1f42a1cefd465e$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $0d1f42a1cefd465e$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $0d1f42a1cefd465e$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$0d1f42a1cefd465e$export$bdfd709ae4826697 = $0d1f42a1cefd465e$var$getBundleURLCached;
$0d1f42a1cefd465e$export$c9e73fbda7da57b6 = $0d1f42a1cefd465e$var$getBaseURL;
$0d1f42a1cefd465e$export$5a759dc7a1cfb72a = $0d1f42a1cefd465e$var$getOrigin;

});

parcelRegister("i4dt5", function(module, exports) {

$parcel$export(module.exports, "getBoardBackground", function () { return $d2730c3b7d3cd4a0$export$c4c46bad752d591; });
$parcel$export(module.exports, "getCardStatusAndData", function () { return $d2730c3b7d3cd4a0$export$f91343abda391f69; });
$parcel$export(module.exports, "batchGetCardStatusAndData", function () { return $d2730c3b7d3cd4a0$export$4209193825acda6; });
$parcel$export(module.exports, "postCardToTrello", function () { return $d2730c3b7d3cd4a0$export$66bee85da68380c6; });
$parcel$export(module.exports, "getOrgData", function () { return $d2730c3b7d3cd4a0$export$b33cb91588a77588; });
const $d2730c3b7d3cd4a0$var$apiKey = "c735a3b2ad7ed17c1b1e97ca9b100ec6";
async function $d2730c3b7d3cd4a0$export$c4c46bad752d591(t, boardId) {
    const token = await t.get("member", "private", "token");
    if (!token || token.includes("rejected")) return null;
    else return fetch(`https://api.trello.com/1/boards/${boardId}?fields=prefs&key=${$d2730c3b7d3cd4a0$var$apiKey}&token=${token}`).then((response)=>response.json()).then((data)=>{
        if (data.prefs) return {
            url: data.prefs.backgroundImage,
            color: data.prefs.backgroundColor,
            topColor: data.prefs.backgroundTopColor,
            brightness: data.prefs.backgroundBrightness
        };
        return null;
    }).catch((error)=>{
        console.error("Failed to fetch Trello board background:", error);
        return null;
    });
}
async function $d2730c3b7d3cd4a0$export$f91343abda391f69(t, cardId) {
    const token = await t.get("member", "private", "token");
    if (!token || token.includes("rejected")) return null;
    else return fetch(`https://api.trello.com/1/cards/${cardId}?checklists=all&members=true&key=${$d2730c3b7d3cd4a0$var$apiKey}&token=${token}`).then(async (response)=>{
        const status = response.status; // Capture the status
        // Check if the response is OK (status in range 200-299)
        if (response.ok) {
            const data = await response.json(); // Parse the JSON data
            return {
                status: status,
                data: data
            }; // Return both status and data
        }
        // For other error statuses (not handled above), return status and no data
        return {
            status: status,
            data: null
        };
    }).catch((error)=>{
        console.error("Failed to fetch card status:", error);
        return {
            status: "error",
            data: null
        }; // Return an error status and null data for network issues
    });
}
async function $d2730c3b7d3cd4a0$export$4209193825acda6(t, cardIds) {
    const token = await t.get("member", "private", "token");
    if (!token || token.includes("rejected")) return null;
    const batchUrls = cardIds.map((cardId)=>encodeURIComponent(`/cards/${cardId}?checklists=all&members=true`));
    // Split the cardIds into batches of 10 (as the batch API allows max 10 requests at a time)
    const batchedUrls = [];
    while(batchUrls.length)batchedUrls.push(batchUrls.splice(0, 10));
    const allResults = [];
    // Fetch data in batches using Trello's batch API
    await Promise.all(batchedUrls.map(async (batch)=>{
        const batchResponse = await fetch(`https://api.trello.com/1/batch?urls=${batch.join(",")}&key=${$d2730c3b7d3cd4a0$var$apiKey}&token=${token}`);
        const batchData = await batchResponse.json();
        // Process each response
        batchData.forEach((response, index)=>{
            // Safely extract cardId from the batch URL
            const urlParts = decodeURIComponent(batch[index]).match(/\/cards\/([^?]+)/);
            const cardId = urlParts ? urlParts[1] : null;
            if (response[200]) allResults.push({
                id: cardId,
                status: 200,
                data: response[200]
            });
            else if (response.statusCode === 401 || response.statusCode === 404) allResults.push({
                id: cardId,
                status: response.statusCode,
                data: null
            });
            else allResults.push({
                id: cardId,
                status: "error",
                data: null
            });
        });
    }));
    return allResults; // Array of results for all cardIds
}
async function $d2730c3b7d3cd4a0$export$66bee85da68380c6(t, cardName, selectedListId) {
    const token = await t.get("member", "private", "token");
    if (!token || token.includes("rejected")) return null;
    else {
        const url = `https://api.trello.com/1/cards?name=${encodeURIComponent(cardName)}&idList=${selectedListId}&key=${$d2730c3b7d3cd4a0$var$apiKey}&token=${token}`;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json"
                }
            });
            if (!response.ok) throw new Error(`Network response was not ok: ${response.statusText}`);
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Error posting card to Trello:", error);
        }
    }
}
async function $d2730c3b7d3cd4a0$export$b33cb91588a77588(t) {
    const organization = await t.organization("id");
    const organizationId = organization.id;
    const token = await t.get("member", "private", "token");
    if (!token || token.includes("rejected")) return null;
    let orgData = {
        boards: [],
        lists: [],
        cards: []
    };
    // Find boards that the member has access to for this organization
    const boardOptions = await $d2730c3b7d3cd4a0$export$d57cdd672817613c(token, organizationId);
    orgData.boards = boardOptions;
    // Prepare batch requests for lists and cards, ensuring proper URI encoding
    const batchUrls = [];
    boardOptions.forEach((board)=>{
        batchUrls.push(encodeURIComponent(`/boards/${board.id}/lists?filter=open`));
        batchUrls.push(encodeURIComponent(`/boards/${board.id}/cards?filter=visible&checklists=all&members=true`));
    });
    // Split into batches of 10 requests
    const batchedUrls = [];
    while(batchUrls.length)batchedUrls.push(batchUrls.splice(0, 10));
    // Use Promise.all to fetch data in batches
    await Promise.all(batchedUrls.map(async (batch)=>{
        const batchResponse = await fetch(`https://api.trello.com/1/batch?urls=${batch}&key=${$d2730c3b7d3cd4a0$var$apiKey}&token=${token}`);
        const batchData = await batchResponse.json();
        // Process each response in the batchData array
        batchData.forEach((response, index)=>{
            const route = decodeURIComponent(batch[index]);
            if (response?.[200]) {
                if (route.includes("/lists")) // Process lists
                orgData.lists = orgData.lists.concat(response[200]);
                else if (route.includes("/cards")) // Process cards
                orgData.cards = orgData.cards.concat(response[200]);
            } else // Log the entire response for debugging
            console.error(`Error fetching data for ${route}:`, response);
        });
    }));
    return orgData;
}
async function $d2730c3b7d3cd4a0$export$d57cdd672817613c(token, organizationId) {
    const fields = [
        "id",
        "name",
        "idOrganization",
        "url"
    ];
    if (!token || token.includes("rejected")) return null;
    else return fetch(`https://api.trello.com/1/organizations/${organizationId}/boards?fields=${fields}&filter=open&key=${$d2730c3b7d3cd4a0$var$apiKey}&token=${token}`).then((response)=>response.json()).then((data)=>{
        if (data) return data;
        return null;
    }).catch((error)=>{
        console.error("Failed to fetch org boards:", error);
        return null;
    });
}
async function $d2730c3b7d3cd4a0$export$f8bc96c8151939ff(t, organizationId) {
    const token = await t.get("member", "private", "token");
    if (!token || token.includes("rejected")) return null;
    try {
        const response = await fetch(`https://api.trello.com/1/organizations/${organizationId}/pluginData?key=${$d2730c3b7d3cd4a0$var$apiKey}&token=${token}`);
        const data = await response.json();
        return {
            status: response.status,
            data: data
        };
    } catch (error) {
        console.error("Failed to fetch org pluginData:", error);
        return {
            status: "error",
            data: null,
            error: error.message
        };
    }
}

});

parcelRegister("gLDcD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c34f71fce0302eff$export$2e2bcd8739ae039; });

var $hc5x0 = parcelRequire("hc5x0");

var $dgI2w = parcelRequire("dgI2w");

var $igBJG = parcelRequire("igBJG");

var $32oyj = parcelRequire("32oyj");
const $c34f71fce0302eff$var$getCardRelationshipsData = async (t)=>{
    try {
        // Ensure `t` is not null or undefined
        if (!t) throw new Error("Trello iframe context (t) is not initialized.");
        if ("Card Relationships".includes("LOCAL")) {
            const localCardRelationships = await t.get("organization", "shared", "localCardRelationships");
            // Handle legacy format for local dev
            if (localCardRelationships && !("version" in localCardRelationships)) // Use migration utility for local dev (skip Netlify POST)
            return await (0, $igBJG.migrateVersionToCardRelationshipsData)({
                t: t,
                orgId: "local-dev",
                token: null,
                legacyData: localCardRelationships
            });
            return localCardRelationships;
        }
        const org = await t.organization("id");
        const token = await (0, $dgI2w.fetchNetlifyAuthToken)();
        const response = await fetch(`/.netlify/functions/cardRelationshipsApi?organizationId=${org.id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        });
        if (!response.ok) throw new Error(`Response was not ok fetching card relationships data: ${response.status}`);
        const dataString = await response.json();
        // If no data exists, then run the database migration
        if (response.ok && !dataString) {
            const migratedData = await (0, $hc5x0.migrateOldDataToNetlify)({
                t: t,
                orgId: org.id
            });
            return {
                version: null,
                data: migratedData
            };
        }
        const data = JSON.parse(dataString);
        // Handle legacy format for Netlify
        if (data && !("version" in data)) // Use migration utility to POST new format and return it
        return await (0, $igBJG.migrateVersionToCardRelationshipsData)({
            t: t,
            orgId: org.id,
            token: token,
            legacyData: data
        });
        return data; // Expect data to be { version, data }
    } catch (error) {
        console.error("Error fetching card relationships data:", error);
        const org = await t.organization("id");
        (0, $32oyj.trackSentryEvent)("getCardRelationshipsData_error", {
            error: error.message,
            organization_id: org.id
        });
        return {
            version: null,
            data: null
        };
    }
};
var $c34f71fce0302eff$export$2e2bcd8739ae039 = $c34f71fce0302eff$var$getCardRelationshipsData;

});
parcelRegister("hc5x0", function(module, exports) {

$parcel$export(module.exports, "migrateOldDataToNetlify", function () { return $c847d91689d439e7$export$2560885c179fe395; });

var $gLDcD = parcelRequire("gLDcD");

var $4tsPV = parcelRequire("4tsPV");

var $dgI2w = parcelRequire("dgI2w");
async function $c847d91689d439e7$export$2560885c179fe395({ t: t, orgId: orgId }) {
    console.log(`Attempting migration for orgId=${orgId}`);
    try {
        // 1) Fetch the existing migration list
        const token = await (0, $dgI2w.fetchNetlifyAuthToken)();
        const listResponse = await fetch("/.netlify/functions/cardRelationshipsApi?organizationId=cardRelationshipsMigrationList", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        });
        const listText = await listResponse.json();
        let migrationList = JSON.parse(listText);
        // 2) If not in the list, read old Trello data
        const oldTrelloData = await t.get("organization", "shared", "cardRelationships");
        if (!oldTrelloData || Object.keys(oldTrelloData).length === 0) {
            // No old data to migrate, just mark migration done
            migrationList[orgId] = {
                migrationDate: new Date().toISOString(),
                trelloDataCleanup: true
            };
            const version = new Date().toISOString();
            await (0, $4tsPV.postEmptyCardRelationshipsData)({
                t: t,
                version: version
            });
            await $c847d91689d439e7$var$postMigrationList(migrationList);
            return {};
        }
        // 3) Save old data to Netlify
        const version = new Date().toISOString();
        const saveResp = await fetch("/.netlify/functions/cardRelationshipsApi", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                organizationId: orgId,
                version: version,
                data: oldTrelloData
            })
        });
        if (!saveResp.ok) throw new Error("Failed to save old Trello data to Netlify");
        // 4) Update the migration list with date + no cleanup
        migrationList[orgId] = {
            migrationDate: version,
            trelloDataCleanup: false
        };
        await $c847d91689d439e7$var$postMigrationList(migrationList);
        // 5) Re-fetch from netlify to confirm
        console.log(`Migration was successful for orgId=${orgId}`);
        const data = await (0, $gLDcD.default)(t);
        return data;
    } catch (error) {
        console.error("Migration error for org", orgId, error);
        return {};
    }
}
async function $c847d91689d439e7$var$postMigrationList(migrationList) {
    const token = await (0, $dgI2w.fetchNetlifyAuthToken)();
    const version = new Date().toISOString();
    await fetch("/.netlify/functions/cardRelationshipsApi", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
            organizationId: "cardRelationshipsMigrationList",
            version: version,
            data: migrationList
        })
    });
}

});
parcelRegister("4tsPV", function(module, exports) {

$parcel$export(module.exports, "postEmptyCardRelationshipsData", function () { return $34203d312f31f2c2$export$d426be6b124ad50d; });

var $dgI2w = parcelRequire("dgI2w");
const $34203d312f31f2c2$export$d426be6b124ad50d = async ({ t: t, version: version })=>{
    try {
        // If local dev, set local data
        if ("Card Relationships".includes("LOCAL")) await t.set("organization", "shared", "localCardRelationships", {
            version: version,
            cardRelationshipsData: {}
        });
        else // Otherwise, post to Netlify function
        try {
            const token = await (0, $dgI2w.fetchNetlifyAuthToken)();
            const organization = await t.organization("id") || {};
            const response = await fetch("/.netlify/functions/cardRelationshipsApi", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    organizationId: organization.id,
                    version: version,
                    data: {}
                })
            });
            const result = await response.json();
            if (!response.ok) console.error("Response was not ok for postEmptyCardRelationshipsData:", result);
        } catch (error) {
            console.error("Error in postEmptyCardRelationshipsData:", error);
        }
    } catch (error) {
        console.error("Failed postEmptyCardRelationshipsData:", error);
    }
};

});
parcelRegister("dgI2w", function(module, exports) {

$parcel$export(module.exports, "fetchNetlifyAuthToken", function () { return $9a8eee59f851ceb5$export$6f4c6014885f1ccc; });
// Function to fetch the Netlify authentication token
const $9a8eee59f851ceb5$export$6f4c6014885f1ccc = async ()=>{
    try {
        const response = await fetch("/.netlify/functions/authenticate", {
            method: "POST"
        });
        if (!response.ok) throw new Error("Failed to obtain token");
        const { token: token } = await response.json();
        return token;
    } catch (error) {
        console.error("Error obtaining token:", error);
        throw error;
    }
};

});



parcelRegister("igBJG", function(module, exports) {

$parcel$export(module.exports, "migrateVersionToCardRelationshipsData", function () { return $d4c6fe2828e98b5e$export$b4bdcf3ba3553e48; });
// Utility to migrate legacy card relationships data to the new format
// Usage: Call this function with t, orgId, token, and the legacy data

var $32oyj = parcelRequire("32oyj");
async function $d4c6fe2828e98b5e$export$b4bdcf3ba3553e48({ t: t, orgId: orgId, token: token, legacyData: legacyData }) {
    const version = new Date().toISOString();
    (0, $32oyj.trackSentryEvent)("migration_legacy_data", {
        organization_id: orgId,
        dataKeys: Object.keys(legacyData).length,
        version: version
    });
    if ("Card Relationships".includes("LOCAL")) // For local dev, store the new format in Trello local storage
    await t.set("organization", "shared", "localCardRelationships", {
        version: version,
        data: legacyData
    });
    else // POST to Netlify in new format
    await fetch("/.netlify/functions/cardRelationshipsApi", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
            organizationId: orgId,
            version: version,
            data: legacyData
        })
    });
    // Return the new format
    return {
        version: version,
        data: legacyData
    };
}

});


parcelRegister("d1W0V", function(module, exports) {

$parcel$export(module.exports, "getCustomer", function () { return $97c85eb1f167635c$export$b5b1cbe405b7010a; });
$parcel$export(module.exports, "updateCustomer", function () { return $97c85eb1f167635c$export$bef73de7c08bced2; });
$parcel$export(module.exports, "updateLocalStorageData", function () { return $97c85eb1f167635c$export$ec13c725e067146a; });
$parcel$export(module.exports, "updateCustomerDataOnEnable", function () { return $97c85eb1f167635c$export$8ef52870550f74d; });
$parcel$export(module.exports, "openSubscribeModal", function () { return $97c85eb1f167635c$export$e469b1b85001f4b4; });
$parcel$export(module.exports, "openStripeCustomerPortal", function () { return $97c85eb1f167635c$export$9b663ab5964dee96; });

var $dgI2w = parcelRequire("dgI2w");
// Define a constant for the cache duration
const $97c85eb1f167635c$var$CACHE_DURATION_MS = 86400000; // 1 day
const $97c85eb1f167635c$export$b5b1cbe405b7010a = async (t)=>{
    const organization = await t.organization("id");
    const organizationId = organization.id;
    const localStorageKey = `${organizationId}-customerData`;
    try {
        // Check localStorage for cached data
        const cachedDataString = localStorage.getItem(localStorageKey);
        const cachedData = cachedDataString ? JSON.parse(cachedDataString) : null;
        const currentTime = new Date().getTime();
        // Check if data is available in localStorage and is not older than the cache duration
        if (cachedData && currentTime - cachedData.timestamp < $97c85eb1f167635c$var$CACHE_DURATION_MS && !cachedData.updateLocalStorageData) return cachedData.data;
        // Fetch from server if not in localStorage or outdated
        if ("Card Relationships".includes("LOCAL")) {
            // Use Trello's storage for local development
            const localCustomerData = await t.get("organization", "shared", "localCustomerData");
            // If no data exists, then create early adopter customer and return the data
            if (!localCustomerData) return await $97c85eb1f167635c$export$7521524f97bd76e3(t);
            // Store fetched data and timestamp in localStorage
            const dataToStore = {
                data: localCustomerData,
                timestamp: currentTime,
                updateLocalStorageData: false
            };
            localStorage.setItem(localStorageKey, JSON.stringify(dataToStore));
            return localCustomerData;
        } else {
            // use Netlify blob storage for non-local development
            const token = await (0, $dgI2w.fetchNetlifyAuthToken)();
            const response = await fetch(`/.netlify/functions/customerApi?organizationId=${organizationId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error("Failed to fetch customer data");
            const customerDataString = await response.json();
            // If no data exists, then create early adopter customer and return the data
            if (response.ok && !customerDataString) return await $97c85eb1f167635c$export$7521524f97bd76e3(t);
            const customerDataObject = JSON.parse(customerDataString);
            // Store fetched data and timestamp in localStorage
            const dataToStore = {
                data: customerDataObject,
                timestamp: currentTime,
                updateLocalStorageData: false
            };
            localStorage.setItem(localStorageKey, JSON.stringify(dataToStore));
            return customerDataObject;
        }
    } catch (error) {
        console.error("Error fetching customer data in getCustomer:", error);
        throw new Error("Failed to retrieve customer data.");
    }
};
const $97c85eb1f167635c$export$bef73de7c08bced2 = async ({ t: t, createdDate: createdDate, earlyAdopter: earlyAdopter, stripeCustomerId: stripeCustomerId, stripeSubscriptionId: stripeSubscriptionId, stripeSubscriptionStatus: stripeSubscriptionStatus })=>{
    try {
        const organization = await t.organization("id", "name");
        const organizationId = organization.id;
        const organizationName = organization.name;
        // Fetch existing customer data
        const existingData = earlyAdopter ? {} : await $97c85eb1f167635c$export$b5b1cbe405b7010a(t);
        // Merge existing data with new data
        const customerData = {
            organizationId: organizationId,
            data: {
                organizationName: organizationName,
                createdDate: createdDate || existingData.createdDate || null,
                earlyAdopter: earlyAdopter !== undefined ? earlyAdopter : existingData.earlyAdopter,
                stripeCustomerId: stripeCustomerId || existingData.stripeCustomerId || null,
                stripeSubscriptionId: stripeSubscriptionId || existingData.stripeSubscriptionId || null,
                stripeSubscriptionStatus: stripeSubscriptionStatus || existingData.stripeSubscriptionStatus || null
            }
        };
        const localCustomerData = {
            organizationId: organizationId,
            ...customerData.data
        };
        if ("Card Relationships".includes("LOCAL")) // Use Trello's storage for local development
        await t.set("organization", "shared", "localCustomerData", localCustomerData);
        else {
            // Use server for non-local environments
            const token = await (0, $dgI2w.fetchNetlifyAuthToken)();
            const response = await fetch("/.netlify/functions/customerApi", {
                method: "POST",
                body: JSON.stringify(customerData),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error("Failed to update customer data");
        }
        // Store data and timestamp in localStorage
        const localStorageKey = `${organizationId}-customerData`;
        const currentTime = new Date().getTime();
        const dataToStore = {
            data: localCustomerData,
            timestamp: currentTime,
            updateLocalStorageData: false
        };
        localStorage.setItem(localStorageKey, JSON.stringify(dataToStore));
    } catch (error) {
        console.error("Error updating customer data:", error);
        throw new Error("Failed to update customer data.");
    }
};
const $97c85eb1f167635c$export$ec13c725e067146a = async (t)=>{
    const organization = await t.organization("id");
    const organizationId = organization.id;
    // Set the flag to fetch and update local storage
    const localStorageKey = `${organizationId}-customerData`;
    const cachedDataString = localStorage.getItem(localStorageKey);
    const cachedData = cachedDataString ? JSON.parse(cachedDataString) : {};
    cachedData.updateLocalStorageData = true;
    localStorage.setItem(localStorageKey, JSON.stringify(cachedData));
};
const $97c85eb1f167635c$export$8ef52870550f74d = async (t)=>{
    const organization = await t.organization("id");
    const organizationId = organization.id;
    const createdDate = new Date().toISOString();
    try {
        // Use Trello's storage for local development
        if ("Card Relationships".includes("LOCAL")) {
            const localCustomerData = await t.get("organization", "shared", "localCustomerData");
            // If no data exists, then create new customer
            if (!localCustomerData) await $97c85eb1f167635c$export$bef73de7c08bced2({
                t: t,
                createdDate: createdDate,
                earlyAdopter: false,
                stripeCustomerId: null,
                stripeSubscriptionId: null,
                stripeSubscriptionStatus: null
            });
        } else {
            // use Netlify blob storage for non-local development
            const token = await (0, $dgI2w.fetchNetlifyAuthToken)();
            const response = await fetch(`/.netlify/functions/customerApi?organizationId=${organizationId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error("Failed to fetch customer data");
            const customerData = await response.json();
            // If no data exists, then create new customer
            if (response.ok && !customerData) await $97c85eb1f167635c$export$bef73de7c08bced2({
                t: t,
                createdDate: createdDate,
                earlyAdopter: false,
                stripeCustomerId: null,
                stripeSubscriptionId: null,
                stripeSubscriptionStatus: null
            });
        }
    } catch (error) {
        console.error("Error updating customer data on enable:", error);
        throw error;
    }
};
async function $97c85eb1f167635c$export$7521524f97bd76e3(t) {
    const createdDate = new Date().toISOString();
    const customerData = {
        t: t,
        createdDate: createdDate,
        earlyAdopter: true,
        stripeCustomerId: null,
        stripeSubscriptionId: null,
        stripeSubscriptionStatus: null
    };
    await $97c85eb1f167635c$export$bef73de7c08bced2(customerData);
    return customerData;
}
async function $97c85eb1f167635c$export$e469b1b85001f4b4(t) {
    return t.modal({
        title: "Card Relationships",
        accentColor: "#0055cc",
        url: "./subscribe.html"
    });
}
const $97c85eb1f167635c$export$9b663ab5964dee96 = async (stripeCustomerId)=>{
    try {
        const response = await fetch("/.netlify/functions/create-customer-portal-session", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                stripeCustomerId: stripeCustomerId
            })
        });
        const data = await response.json();
        if (response.ok) window.open(data.url, "_blank");
        else console.error("Error creating customer portal session:", data.error);
    } catch (error) {
        console.error("Error opening Stripe customer portal:", error);
    }
};

});

parcelRegister("dULdM", function(module, exports) {

$parcel$export(module.exports, "checkAuthorizationAndSubscription", function () { return $a215227a545ad743$export$2605383dd8fc2e34; });

var $d1W0V = parcelRequire("d1W0V");

var $hpCwz = parcelRequire("hpCwz");

var $5o3N8 = parcelRequire("5o3N8");
const $a215227a545ad743$export$2605383dd8fc2e34 = async (t)=>{
    const token = await t.get("member", "private", "token");
    if (!token || token.includes("rejected")) {
        // Return Auth modal if the user is not yet authorized
        await t.modal({
            title: "",
            accentColor: "#1064E3",
            url: "./authorize.html",
            height: 593,
            args: {
                trigger: "show-authorization"
            }
        });
        return false;
    } else {
        // Remove after successful launch (start)
        if (!await (0, $5o3N8.isFeatureEnabled)({
            t: t
        })) // If the subscription feature is not enabled, let the user through
        return true;
        // Remove after successful launch (end)
        const { stripeSubscriptionStatus: stripeSubscriptionStatus, earlyAdopter: earlyAdopter, createdDate: createdDate } = await (0, $d1W0V.getCustomer)(t);
        const trialDaysLeft = (0, $hpCwz.calculateTrialDaysLeft)(createdDate);
        const activeSubscription = stripeSubscriptionStatus === "active";
        if (!activeSubscription && !earlyAdopter && trialDaysLeft <= 0) {
            // If the user is not subscribed and the trial has ended, open the subscribe modal
            await (0, $d1W0V.openSubscribeModal)(t);
            return false;
        }
    }
    return true;
};

});
parcelRegister("hpCwz", function(module, exports) {

$parcel$export(module.exports, "calculateTrialDaysLeft", function () { return $cad2a799240a033b$export$fb27b36ffeb57a20; });
const $cad2a799240a033b$export$fb27b36ffeb57a20 = (createdDate)=>{
    const trialDuration = 14; // days
    const currentDate = new Date();
    const startDate = new Date(createdDate);
    const diffDays = Math.ceil((startDate.getTime() + trialDuration * 86400000 - currentDate.getTime()) / 86400000);
    return diffDays > 0 ? diffDays : 0;
};

});

parcelRegister("5o3N8", function(module, exports) {

$parcel$export(module.exports, "isFeatureEnabled", function () { return $3ec22291a3dcce7b$export$87e0f7dd6dec932f; });
// Utility function to check if the feature is enabled
// Currently using this feature flag for subscription/customer data
async function $3ec22291a3dcce7b$export$87e0f7dd6dec932f({ organizationId: organizationId, t: t }) {
    if (!organizationId) {
        const organization = await t.organization("id");
        organizationId = organization.id;
    }
    //return organizationId === process.env.FEATURE_FLAG_ORGANIZATION_ID; // Enable this to enable the feature for my specific organization
    return false; // False to disable the feature
//return true; // True to enable the feature
}

});


var $b02185bef8ae2c16$exports = {};


(parcelRequire("lGKbD")).register((parcelRequire("17QCl")).getBundleURL("jbgnD"), JSON.parse('["jbgnD","index.fa824597.js","avmFF","card-relationships-icon-main.e8c2be10.svg"]'));


var $i4dt5 = parcelRequire("i4dt5");
// Convert HEX to RGB
function $75a0d4b4c07e0238$var$hexToRGB(hex) {
    return {
        r: parseInt(hex.slice(1, 3), 16),
        g: parseInt(hex.slice(3, 5), 16),
        b: parseInt(hex.slice(5, 7), 16)
    };
}
// Convert RGB to HSL
function $75a0d4b4c07e0238$var$rgbToHSL({ r: r, g: g, b: b }) {
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;
    if (max === min) h = s = 0; // achromatic
    else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: Math.round(h * 360),
        s: s * 100,
        l: l * 100
    };
}
// Adjust HSL for light background
function $75a0d4b4c07e0238$var$adjustHSLForLightBackground(hsl) {
    hsl.s = Math.max(0, Math.min(100, hsl.s * 0.9)); // reduce saturation
    hsl.l = Math.max(0, Math.min(100, hsl.l + (100 - hsl.l) * 0.05)); // slightly increase lightness
    return hsl;
}
// Adjust HSL for dark background
function $75a0d4b4c07e0238$var$adjustHSLForDarkBackground(hsl) {
    hsl.s = Math.max(0, Math.min(100, hsl.s * 1.1)); // increase saturation
    hsl.l = Math.max(0, Math.min(100, hsl.l * 0.35)); // decrease lightness
    return hsl;
}
// Convert HSL to RGB
function $75a0d4b4c07e0238$var$hslToRGB({ h: h, s: s, l: l }) {
    s /= 100;
    l /= 100;
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(h / 60 % 2 - 1));
    const m = l - c / 2;
    let r = 0, g = 0, b = 0;
    if (h >= 0 && h < 60) {
        r = c;
        g = x;
        b = 0;
    } else if (h >= 60 && h < 120) {
        r = x;
        g = c;
        b = 0;
    } else if (h >= 120 && h < 180) {
        r = 0;
        g = c;
        b = x;
    } else if (h >= 180 && h < 240) {
        r = 0;
        g = x;
        b = c;
    } else if (h >= 240 && h < 300) {
        r = x;
        g = 0;
        b = c;
    } else if (h >= 300 && h < 360) {
        r = c;
        g = 0;
        b = x;
    }
    r = Math.max(0, Math.min(255, Math.round((r + m) * 255)));
    g = Math.max(0, Math.min(255, Math.round((g + m) * 255)));
    b = Math.max(0, Math.min(255, Math.round((b + m) * 255)));
    return {
        r: r,
        g: g,
        b: b
    };
}
// Convert RGB to HEX
function $75a0d4b4c07e0238$var$rgbToHex({ r: r, g: g, b: b }) {
    const red = r.toString(16).padStart(2, "0");
    const green = g.toString(16).padStart(2, "0");
    const blue = b.toString(16).padStart(2, "0");
    return `#${red}${green}${blue}`;
}
function $75a0d4b4c07e0238$export$138a295197399d4d(hex, background) {
    let rgb = $75a0d4b4c07e0238$var$hexToRGB(hex);
    let hsl = $75a0d4b4c07e0238$var$rgbToHSL(rgb);
    if (background === "light") hsl = $75a0d4b4c07e0238$var$adjustHSLForLightBackground(hsl);
    else if (background === "dark") hsl = $75a0d4b4c07e0238$var$adjustHSLForDarkBackground(hsl);
    rgb = $75a0d4b4c07e0238$var$hslToRGB(hsl);
    return $75a0d4b4c07e0238$var$rgbToHex(rgb);
}


var $7381955513366c14$exports = {};

$7381955513366c14$exports = (parcelRequire("17QCl")).getBundleURL("jbgnD") + "card-relationships-icon-main.e8c2be10.svg";


parcelRequire("gLDcD");
parcelRequire("4tsPV");

var $d1W0V = parcelRequire("d1W0V");

var $dULdM = parcelRequire("dULdM");

var $5o3N8 = parcelRequire("5o3N8");

var $32oyj = parcelRequire("32oyj");
// Initialize Sentry for global error logging and analytics
(0, $32oyj.initializeSentry)();
window.TrelloPowerUp.initialize({
    "board-buttons": function(t, opts) {
        return [
            {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($7381955513366c14$exports))),
                text: "Card Relationships",
                condition: "edit",
                callback: $556b009b0c13cb48$var$openModal
            }
        ];
    },
    "card-back-section": function(t, opts) {
        if (!$556b009b0c13cb48$var$powerupPermission(t)) return;
        return {
            title: "Relationships",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7381955513366c14$exports))),
            content: {
                type: "iframe",
                url: t.signUrl("./card-back.html"),
                height: 40
            },
            action: {
                text: "View all",
                callback: $556b009b0c13cb48$var$openModal
            }
        };
    },
    "show-settings": function(t, opts) {
        return t.popup({
            title: "Card Relationships Settings",
            url: "./settings.html"
        });
    },
    "on-enable": async function(t, opts) {
        // THE BELOW IS COMMENTED OUT WHILE MIGRATEOLDDATATONETLIFY HANDLES postEmptyCardRelationshipsData
        // const existingCardRelationships = await getCardRelationshipsData(t);
        // if (!existingCardRelationships) {
        //   await postEmptyCardRelationshipsData(t);
        // }
        // Remove after successful launch (start)
        if (await (0, $5o3N8.isFeatureEnabled)({
            t: t
        })) // If the subscription feature is not enabled, let the user through
        await (0, $d1W0V.updateCustomerDataOnEnable)(t); // KEEP THIS LINE AFTER SUCCESSFUL LAUNCH
        // Remove after successful launch (end)
        // Record analytics
        try {
            const org = await t.organization("id");
            (0, $32oyj.trackSentryEvent)("board_enabled", {
                organization_id: org.id
            });
        } catch (e) {
            // Log but do not block
            console.error("Failed to record enable event", e);
        }
        return t.modal({
            title: "",
            accentColor: "#1064E3",
            url: "./authorize.html",
            height: 593,
            args: {
                trigger: "onEnable"
            }
        });
    },
    "on-disable": async function(t, opts) {
        // Record analytics
        try {
            const org = await t.organization("id");
            (0, $32oyj.trackSentryEvent)("board_disabled", {
                organization_id: org.id
            });
        } catch (e) {
            // Log but do not block
            console.error("Failed to record disable event", e);
        }
        const organization = await t.organization("id");
        return t.modal({
            title: "Card Relationships",
            accentColor: "#1064E3",
            url: "./on-disable.html",
            height: 386,
            args: {
                organizationId: organization.id
            }
        });
    }
}, {
    appKey: "c735a3b2ad7ed17c1b1e97ca9b100ec6",
    appName: "Card Relationships",
    appAuthor: "Native Power-Ups"
});
const $556b009b0c13cb48$var$openModal = async (t)=>{
    if (!await (0, $dULdM.checkAuthorizationAndSubscription)(t)) return; // Exit if the user is not authorized or subscribed
    const context = t.getContext();
    const theme = context.initialTheme;
    const boardId = context.board;
    const background = await (0, $i4dt5.getBoardBackground)(t, boardId);
    const adjustedTopColor = (0, $75a0d4b4c07e0238$export$138a295197399d4d)(background.topColor, background.brightness);
    return t.modal({
        title: "Card Relationships",
        url: "./modal.html",
        accentColor: theme === "dark" ? "#161A1D" : background ? adjustedTopColor : "",
        fullscreen: true
    });
};
const $556b009b0c13cb48$var$powerupPermission = (t)=>{
    const trelloContext = t.getContext();
    const memberCardPermission = trelloContext.permissions.card;
    if (memberCardPermission === "read") return false;
    return true;
};

})();
//# sourceMappingURL=index.fa824597.js.map
